const PIECES: Record<string, string> = {
  k: "♚",
  q: "♛",
  r: "♜",
  b: "♝",
  n: "♞",
  p: "♟",
};

const FILES = "abcdefgh";

interface BoardProps {
  fen: string;
  lastMoveUci?: string;
  orientation?: "w" | "b";
}

/** Salt-görüntü tahta (inceleme/oynatma için; sürükleme yok). */
export function Board({ fen, lastMoveUci, orientation = "w" }: BoardProps) {
  const placement = fen.split(" ")[0];
  const rows = placement.split("/");

  const hlFrom = lastMoveUci && lastMoveUci.length >= 4 ? lastMoveUci.slice(0, 2) : null;
  const hlTo = lastMoveUci && lastMoveUci.length >= 4 ? lastMoveUci.slice(2, 4) : null;

  const ranks = orientation === "w" ? [0, 1, 2, 3, 4, 5, 6, 7] : [7, 6, 5, 4, 3, 2, 1, 0];
  const files = orientation === "w" ? [0, 1, 2, 3, 4, 5, 6, 7] : [7, 6, 5, 4, 3, 2, 1, 0];

  // FEN satırını karelere aç
  const expandRow = (row: string): (string | null)[] => {
    const out: (string | null)[] = [];
    for (const ch of row) {
      if (/\d/.test(ch)) {
        for (let i = 0; i < Number(ch); i++) out.push(null);
      } else {
        out.push(ch);
      }
    }
    return out;
  };
  const grid = rows.map(expandRow);

  return (
    <div className="board" role="grid" aria-label="Satranç tahtası">
      {ranks.map((ri) =>
        files.map((fi) => {
          const piece = grid[ri]?.[fi] ?? null;
          const sq = `${FILES[fi]}${8 - ri}`;
          const light = (ri + fi) % 2 === 0;
          const hl = sq === hlFrom || sq === hlTo;
          return (
            <div key={sq} className={`sq ${light ? "light" : "dark"} ${hl ? "hl" : ""}`}>
              {piece && (
                <span className={`piece ${piece === piece.toUpperCase() ? "pw" : "pb"}`}>
                  {PIECES[piece.toLowerCase()]}
                </span>
              )}
              {fi === files[0] && <span className="coord rank">{8 - ri}</span>}
              {ri === ranks[ranks.length - 1] && <span className="coord file">{FILES[fi]}</span>}
            </div>
          );
        }),
      )}
    </div>
  );
}
